import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.5 1.5C6.5 1.22386 6.27614 1 6 1C5.72386 1 5.5 1.22386 5.5 1.5V7.29289L3.35355 5.14645C3.15829 4.95118 2.84171 4.95118 2.64645 5.14645C2.45118 5.34171 2.45118 5.65829 2.64645 5.85355L5.64645 8.85355C5.84171 9.04882 6.15829 9.04882 6.35355 8.85355L9.35355 5.85355C9.54882 5.65829 9.54882 5.34171 9.35355 5.14645C9.15829 4.95118 8.84171 4.95118 8.64645 5.14645L6.5 7.29289V1.5Z" fill="currentColor" />
      <path d="M1 10.5C1 10.2239 1.22386 10 1.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H1.5C1.22386 11 1 10.7761 1 10.5Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.66665 1.99967C8.66665 1.63148 8.36817 1.33301 7.99998 1.33301C7.63179 1.33301 7.33331 1.63148 7.33331 1.99967V9.72353L4.47138 6.8616C4.21103 6.60125 3.78892 6.60125 3.52857 6.8616C3.26823 7.12195 3.26823 7.54406 3.52857 7.80441L7.52857 11.8044C7.78892 12.0648 8.21103 12.0648 8.47138 11.8044L12.4714 7.80441C12.7317 7.54406 12.7317 7.12195 12.4714 6.8616C12.211 6.60125 11.7889 6.60125 11.5286 6.8616L8.66665 9.72353V1.99967Z" fill="currentColor" />
      <path d="M1.33331 13.9997C1.33331 13.6315 1.63179 13.333 1.99998 13.333H14C14.3682 13.333 14.6666 13.6315 14.6666 13.9997C14.6666 14.3679 14.3682 14.6663 14 14.6663H1.99998C1.63179 14.6663 1.33331 14.3679 1.33331 13.9997Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.8334 2.50033C10.8334 2.04009 10.4603 1.66699 10 1.66699C9.53978 1.66699 9.16669 2.04009 9.16669 2.50033V12.1551L5.58928 8.57774C5.26384 8.2523 4.7362 8.2523 4.41076 8.57774C4.08533 8.90317 4.08533 9.43081 4.41076 9.75625L9.41076 14.7562C9.7362 15.0817 10.2638 15.0817 10.5893 14.7562L15.5893 9.75625C15.9147 9.43081 15.9147 8.90317 15.5893 8.57774C15.2638 8.2523 14.7362 8.2523 14.4108 8.57774L10.8334 12.1551V2.50033Z" fill="currentColor" />
      <path d="M1.66669 17.5003C1.66669 17.0401 2.03978 16.667 2.50002 16.667H17.5C17.9603 16.667 18.3334 17.0401 18.3334 17.5003C18.3334 17.9606 17.9603 18.3337 17.5 18.3337H2.50002C2.03978 18.3337 1.66669 17.9606 1.66669 17.5003Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 10C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H10.5ZM5.5 1.5C5.5 1.22386 5.72386 1 6 1C6.27614 1 6.5 1.22386 6.5 1.5V7.29297L8.64648 5.14648C8.84175 4.95122 9.15825 4.95122 9.35352 5.14648C9.54878 5.34175 9.54878 5.65825 9.35352 5.85352L6.35352 8.85352C6.15825 9.04878 5.84175 9.04878 5.64648 8.85352L2.64648 5.85352L2.6123 5.81543C2.45213 5.61904 2.46343 5.32954 2.64648 5.14648C2.82954 4.96343 3.11904 4.95213 3.31543 5.1123L3.35352 5.14648L5.5 7.29297V1.5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 13.333C14.3682 13.333 14.6666 13.6315 14.6666 13.9997C14.6666 14.3679 14.3682 14.6663 14 14.6663H1.99998C1.63179 14.6663 1.33331 14.3679 1.33331 13.9997C1.33331 13.6315 1.63179 13.333 1.99998 13.333H14ZM7.33331 1.99967C7.33331 1.63148 7.63179 1.33301 7.99998 1.33301C8.36817 1.33301 8.66665 1.63148 8.66665 1.99967V9.72363L11.5286 6.86165C11.789 6.6013 12.211 6.6013 12.4713 6.86165C12.7317 7.122 12.7317 7.54401 12.4713 7.80436L8.47133 11.8044C8.21098 12.0647 7.78897 12.0647 7.52863 11.8044L3.52863 7.80436L3.48305 7.75358C3.26949 7.49173 3.28455 7.10573 3.52863 6.86165C3.7727 6.61758 4.1587 6.60251 4.42055 6.81608L4.47133 6.86165L7.33331 9.72363V1.99967Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5 16.667C17.9603 16.667 18.3334 17.0401 18.3334 17.5003C18.3334 17.9606 17.9603 18.3337 17.5 18.3337H2.50002C2.03978 18.3337 1.66669 17.9606 1.66669 17.5003C1.66669 17.0401 2.03978 16.667 2.50002 16.667H17.5ZM9.16669 2.50033C9.16669 2.04009 9.53978 1.66699 10 1.66699C10.4603 1.66699 10.8334 2.04009 10.8334 2.50033V12.1553L14.4108 8.5778C14.7363 8.25236 15.2638 8.25236 15.5892 8.5778C15.9146 8.90324 15.9146 9.43075 15.5892 9.75618L10.5892 14.7562C10.2638 15.0816 9.73626 15.0816 9.41083 14.7562L4.41083 9.75618L4.35386 9.69271C4.0869 9.3654 4.10573 8.8829 4.41083 8.5778C4.71592 8.2727 5.19842 8.25387 5.52574 8.52083L5.58921 8.5778L9.16669 12.1553V2.50033Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconDownload02: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"download-02"} {...props} />
);
